import {
  DeliveryStatus,
  PaymentMethodType,
  PaymentStatus,
} from '@lojinha/palantir'
import { isReturnedStatus } from './logic'

export enum PurchasesVariants {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  CanceledAfter3Days = 'CANCELED_AFTER_3_DAYS',
  Done = 'DONE',
  MyPurchases = 'MY_PURCHASES',
  Returned = 'RETURNED',
  WaitingAuthorization = 'WAITING_AUTHORIZATION',
  WaitingPayment = 'WAITING_PAYMENT',
}

export const ONLINE_PAYMENT_METHODS = [
  PaymentMethodType.MarketVoucherOnline,
  PaymentMethodType.RestaurantVoucherOnline,
  PaymentMethodType.CreditCard,
]

export const getPurchaseStatus = (
  paymentStatus: PaymentStatus,
  deliveryStatus: DeliveryStatus,
  paymentMethod: PaymentMethodType
) => {
  if (
    paymentStatus === PaymentStatus.Pending ||
    paymentStatus === PaymentStatus.PendingAntifraudCapture ||
    paymentStatus === PaymentStatus.Waiting
  ) {
    if (
      [PaymentMethodType.Boleto, PaymentMethodType.Pix].includes(paymentMethod)
    ) {
      return PurchasesVariants.WaitingPayment
    }

    if (ONLINE_PAYMENT_METHODS.includes(paymentMethod)) {
      return PurchasesVariants.WaitingAuthorization
    }
  }

  if (
    deliveryStatus !== DeliveryStatus.Delivered &&
    (paymentStatus === PaymentStatus.Paid ||
      paymentStatus === PaymentStatus.OnDelivery)
  ) {
    return isReturnedStatus(deliveryStatus)
      ? PurchasesVariants.Returned
      : PurchasesVariants.Approved
  }

  if (paymentStatus === PaymentStatus.Canceled) {
    return PurchasesVariants.Canceled
  }

  if (deliveryStatus === DeliveryStatus.Delivered) {
    return PurchasesVariants.Done
  }

  return PurchasesVariants.Done
}
